
import { createContext, useState } from "react";

const ThemeContext = createContext();

const ThemeProvider = ({children}) => {
    const [theme, setTheme] = useState(true);
    
    const darkTheme = () => {
        let app = document.getElementsByClassName('App');
        let text = document.querySelectorAll('p, label, input, textarea, h1, h2, h3, .text');
        let grayIcon = document.querySelectorAll('.gray-icon');
        let hoverText = document.querySelectorAll('li, .hover-text');
        let submenu = document.getElementById('submenu');

        app && 
        (app[0].style.backgroundColor = '#19191a');

        text &&
        text.forEach((element)=>{
            element.style.color = 'whitesmoke';
        })

        hoverText &&
        hoverText.forEach((element) => {
            element.classList.add('light-text');
        })

        grayIcon &&
        grayIcon.forEach((element) => {
            element.classList.add('light-icon');
        })

        submenu &&
        submenu.classList.add('dark-submenu');
    }

    const lightTheme = () => {
        let app = document.getElementsByClassName('App');
        let text = document.querySelectorAll('p, label, input, textarea, h1, h2, h3, .text');
        let grayIcon = document.querySelectorAll('.gray-icon');
        let hoverText = document.querySelectorAll('li, .hover-text');
        let submenu = document.getElementById('submenu');

        app && 
        (app[0].style.backgroundColor = '#f3f3f3');

        text &&
        text.forEach((element)=>{
            element.style.color = '#2e2e2e';
        })

        hoverText &&
        hoverText.forEach((element) => {
            element.classList.remove('light-text');
        })

        grayIcon &&
        grayIcon.forEach((element) => {
            element.classList.remove('light-icon');
        })

        submenu &&
        submenu.classList.remove('dark-submenu');
    }

    const switchTheme = () => {
        if(theme) {
            setTheme(false);
        } else {
            setTheme(true)
        }
    }

    const dataContext = {
        theme,
        setTheme,
        switchTheme,
        darkTheme,
        lightTheme
    }

    return(
        <ThemeContext.Provider value={dataContext}>
            {children}
        </ThemeContext.Provider>
    )
}

export default ThemeProvider;
export { ThemeContext };